module.exports = __webpack_public_path__ + "img/logback.9e563452.svg";